import { Link } from "react-router-dom";
import { DownloadSimple, Handshake } from "@phosphor-icons/react";
import { Icon } from "@/lib/icons";
import { fmtEur } from "@/lib/api";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const coverSrc = (p) => (p?.cover_url ? `${BASE}${p.cover_url}` : null);

export const productPrice = (p) => {
  if (p.pricing_type === "free") return "Gratis";
  if (p.pricing_type === "contract") return "Según contrato";
  return p.pricing_type === "monthly" ? `${fmtEur(p.price)}/mes` : fmtEur(p.price);
};

export const ProductCard = ({ product: p, index = 0 }) => (
  <Link to={`/product/${p.product_id}`} className="reveal group relative flex flex-col bg-[#0b0b0b] hover:bg-[#121212]" style={{ animationDelay: `${index * 50}ms`, transition: "background-color 200ms" }} data-testid={`product-card-${p.product_id}`}>
    <span className="absolute inset-x-0 top-0 z-10 h-px scale-x-0 bg-cyan-400 group-hover:scale-x-100" style={{ transformOrigin: "left", transition: "transform 300ms ease-out" }} />
    <div className="relative aspect-[16/9] overflow-hidden border-b border-white/5" style={{ background: `${p.color}10` }}>
      {coverSrc(p) ? (
        <img src={coverSrc(p)} alt={p.name} className="h-full w-full object-cover opacity-90 group-hover:scale-[1.03]" style={{ transition: "transform 500ms ease-out" }} />
      ) : (
        <div className="grid-bg grid h-full w-full place-items-center"><Icon name={p.icon} size={52} weight="duotone" style={{ color: p.color }} /></div>
      )}
      {p.featured && <span className="absolute left-3 top-3 bg-cyan-400 px-2 py-0.5 text-[10px] font-bold uppercase tracking-widest text-black">Destacado</span>}
      <span className="absolute right-3 top-3 border border-white/15 bg-black/70 px-2 py-0.5 font-mono text-[10px] text-zinc-300 backdrop-blur">v{p.version}</span>
    </div>
    <div className="flex flex-1 flex-col justify-between p-6">
      <div>
        <p className="text-[11px] font-semibold uppercase tracking-[0.16em] text-zinc-500">{p.category}</p>
        <h3 className="mt-1 font-display text-lg font-bold tracking-tight">{p.name}</h3>
        <p className="mt-1.5 line-clamp-2 text-sm text-zinc-400">{p.tagline}</p>
        {p.specs?.length > 0 && (
          <div className="mt-4 flex flex-wrap gap-1.5">
            {p.specs.slice(0, 3).map((s) => <span key={s.label} className="border border-white/10 px-2 py-0.5 font-mono text-[10px] text-zinc-400">{s.value}</span>)}
          </div>
        )}
      </div>
      <div className="mt-6 flex items-center justify-between border-t border-white/5 pt-4">
        <span className="inline-flex items-center gap-1 text-xs text-zinc-500">
          {p.pricing_type === "contract" ? <Handshake size={13} /> : <DownloadSimple size={13} />} {p.platforms?.length ? p.platforms.join(" · ") : `${p.sales_count || 0} usuarios`}
        </span>
        <span className="font-mono text-sm font-semibold" data-testid={`product-card-price-${p.product_id}`}>{productPrice(p)}</span>
      </div>
    </div>
  </Link>
);
